export default __webpack_public_path__ + "static/media/DatasetView.5d10d937.svg";